module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAUZJREFUWEftlaFLxVAUxr9vj4GgwaYIT7PeFcVosRhUrBbjsxkeCHZBg2gwGUyCbV2rf8LC3S7rYvIfsGxHBg+Zz+mG7G7l3nzh/M6P851D9PzYc304AGfAGWhsII5jKUX2NQiC5TYibB0gTdOlLMt2lFIPVcDWAJIkmRORMwCnJF+UUvudAIRhOFBKjUTkHMBCUZTkUycAWus9ktcAVsvdWgcwxmzkeX4DYLtSsy0DWuuh53mXInJUmP4tFTYMvAF4BDAGMFMXx9YBSL6LyAeAYV1xa0NIcg3ABYATERn8BdK6AQBfm1BrvUnyHsB6lzPwbRVPsj+eZH92GsSqgXIxY8xKlmV3JHc73QPTHWutD0neAli0NoR11zCKonnf968AHJN87mQVVw1hkiRbAA6UUsVh+vEaX8Mmef/PHwfgDDgDvRv4BGdvqyHM1XlWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/player/prev3.png
// module id = 3vl+
// module chunks = 1